module.exports = __webpack_public_path__ + "img/17.a44d781c.png";